import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container animated fadeIn" }
const _hoisted_2 = {
  key: 0,
  class: "rounded mx-0"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4 mb-3" }, "Profile")
  ])
], -1)
const _hoisted_4 = { class: "mb-5 mt-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "col-lg-4 col-md-4 col-sm-6 col-6" }, null, -1)
const _hoisted_7 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_8 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Email")
], -1)
const _hoisted_9 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_10 = {
  key: 0,
  title: "Email confirmed",
  class: "text-success"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_12 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_14 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", null, "Created At", -1)
const _hoisted_16 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_17 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "Address Line:", -1)
const _hoisted_19 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_20 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, "MSB:", -1)
const _hoisted_22 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_23 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, "Nature:", -1)
const _hoisted_25 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_26 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", null, "Entity Name:", -1)
const _hoisted_28 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_29 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", null, "Entity Type:", -1)
const _hoisted_31 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_32 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", null, "Website:", -1)
const _hoisted_34 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_35 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", null, "Is Mines Bitcoin:", -1)
const _hoisted_37 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_38 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", null, "Wallet Address:", -1)
const _hoisted_40 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" No Files. ")
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Authorized Signers   ")
const _hoisted_45 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sm btn-primary" }, "+", -1)
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" No Authorized Signers. ")
const _hoisted_49 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sm btn-warning" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" })
], -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Beneficial Owners ")
const _hoisted_51 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sm btn-primary" }, "+", -1)
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-12" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" No Beneficial Owners. ")
const _hoisted_55 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sm btn-warning" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" })
], -1)
const _hoisted_56 = { class: "row mt-3 mb-3 justify-content-between" }
const _hoisted_57 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_58 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_59 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = { class: "col-lg-4 col-md-4 col-sm-12" }
const _hoisted_66 = { class: "row mt-4" }
const _hoisted_67 = { class: "col-12 d-flex justify-content-end" }
const _hoisted_68 = /*#__PURE__*/_createVNode("small", null, " By setting up and Anti-phishing Code, you will be able to know if the emails and 2FA are from Satstreet or phishing attempts. ", -1)
const _hoisted_69 = { class: "mt-3 row" }
const _hoisted_70 = { class: "col-lg-8 col-md-8 col-sm-12" }
const _hoisted_71 = {
  id: "anti-phishing-word-help",
  class: "form-text"
}
const _hoisted_72 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-shield-alt" }),
  /*#__PURE__*/_createTextVNode(" We recommend changing the code every 30 days to enhance account security. ")
], -1)
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col text-right" }
const _hoisted_77 = /*#__PURE__*/_createVNode("small", null, " Need help? Check out our help page for answers and guidance. Click here to access the help section. ", -1)
const _hoisted_78 = { class: "mt-3" }
const _hoisted_79 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://satstreet.com/services/privacypolicy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Privacy Policy ")
], -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://satstreet.com/services/risk-statements",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Risk Statements ")
], -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://satstreet.com/services/legal-disclosures",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Legal Disclosures ")
], -1)
const _hoisted_82 = { class: "container" }
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("h2", null, "Terms of service")
  ])
], -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Verify2fa = _resolveComponent("Verify2fa")
  const _component_TwoFactorAuthenticator = _resolveComponent("TwoFactorAuthenticator")
  const _component_Panel = _resolveComponent("Panel")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Password = _resolveComponent("Password")
  const _component_Terms = _resolveComponent("Terms")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.userProfile)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Verify2fa, {
            show: _ctx.showVerify,
            email: 'hernny.malaver@gmail.com',
            returnCode: true,
            onClose: _ctx.close2fa,
            onSuccess: _ctx.success2fa
          }, null, 8, ["show", "email", "onClose", "onSuccess"]),
          _createVNode(_component_TwoFactorAuthenticator, {
            show: _ctx.modalShow,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalShow = false))
          }, null, 8, ["show"]),
          _hoisted_3,
          _createVNode(_component_Panel, {
            header: "Information",
            class: "shadow mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode("h4", _hoisted_4, [
                _createVNode("b", null, _toDisplayString(_ctx.userProfile.firstName || '--') + " " + _toDisplayString(_ctx.userProfile.lastName || '--'), 1)
              ]),
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("h6", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.userProfile.email) + " ", 1),
                    (_ctx.userProfile.emailConfirmed)
                      ? (_openBlock(), _createBlock("span", _hoisted_10, [
                          _hoisted_11
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_12, [
                          _hoisted_13
                        ]))
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("b", null, [
                    _hoisted_15,
                    _createVNode("h6", _hoisted_16, _toDisplayString(_ctx.formatDate(_ctx.userProfile.createdAt)), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("b", null, [
                    _hoisted_18,
                    _createVNode("h6", _hoisted_19, _toDisplayString(_ctx.userProfile.addressLine1 || '--'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("b", null, [
                    _hoisted_21,
                    _createVNode("h6", _hoisted_22, _toDisplayString(_ctx.userProfile.corporate?.MSB ? 'YES' : 'NO'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("b", null, [
                    _hoisted_24,
                    _createVNode("h6", _hoisted_25, _toDisplayString(_ctx.userProfile.corporate?.businessNature || '--'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("b", null, [
                    _hoisted_27,
                    _createVNode("h6", _hoisted_28, _toDisplayString(_ctx.userProfile.corporate?.entityName || '--'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("b", null, [
                    _hoisted_30,
                    _createVNode("h6", _hoisted_31, _toDisplayString(_ctx.userProfile.corporate?.entityType || '--'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_32, [
                  _createVNode("b", null, [
                    _hoisted_33,
                    _createVNode("h6", _hoisted_34, [
                      _createVNode("a", {
                        href: _ctx.userProfile.corporate?.website,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(_ctx.userProfile.corporate?.website || '--'), 9, ["href"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("b", null, [
                    _hoisted_36,
                    _createVNode("h6", _hoisted_37, _toDisplayString(_ctx.userProfile.corporate?.minesBitcoin ? 'YES' : 'NO'), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_38, [
                  _createVNode("b", null, [
                    _hoisted_39,
                    _createVNode("h6", _hoisted_40, _toDisplayString(_ctx.userProfile.corporate?.walletAddress || '---'), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            header: "Files",
            class: "shadow mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_41, [
                _createVNode(_component_DataTable, {
                  value: _ctx.filterFiles,
                  autoLayout: true,
                  filterDisplay: "menu"
                }, {
                  empty: _withCtx(() => [
                    _hoisted_42
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      header: "Document",
                      bodyStyle: "text-align: left"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_ctx.titleize(slotProps.data.typeOfDocument)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "uploadedAt",
                      header: "Uploaded At",
                      bodyStyle: "text-align: left"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Action",
                      bodyStyle: "text-align: left"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("button", {
                          class: "btn btn-sm btn-primary",
                          onClick: ($event: any) => (_ctx.downloadDocument(slotProps.data))
                        }, [
                          _hoisted_43
                        ], 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, { class: "shadow mt-3" }, {
            header: _withCtx(() => [
              _createVNode("b", null, [
                _hoisted_44,
                _createVNode(_component_router_link, { to: {
                name: 'create.signer'
              } }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode(_component_DataTable, {
                    value: _ctx.userProfile.corporate?.authorizedSigners,
                    autoLayout: true,
                    filterDisplay: "menu"
                  }, {
                    empty: _withCtx(() => [
                      _hoisted_48
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "email",
                        header: "Email",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(_ctx.hideEmail(slotProps.data.email)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "name",
                        header: "Name",
                        bodyStyle: "text-align: left"
                      }),
                      _createVNode(_component_Column, {
                        header: "Related With Governament",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.relatedGovernment ? 'YES' : 'NO'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        header: "Actions",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_router_link, {
                            to: {
                      name: 'edit.signer',
                      params: { signerId: slotProps.data.id }
                    }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_49
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, { class: "shadow mt-3" }, {
            header: _withCtx(() => [
              _createVNode("b", null, [
                _hoisted_50,
                _createVNode(_component_router_link, { to: {
                name: 'create.beneficial'
              } }, {
                  default: _withCtx(() => [
                    _hoisted_51
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, [
                  _createVNode(_component_DataTable, {
                    value: _ctx.userProfile.corporate?.beneficialOwners,
                    autoLayout: true
                  }, {
                    empty: _withCtx(() => [
                      _hoisted_54
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "email",
                        header: "Email",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(_ctx.hideEmail(slotProps.data.email)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "name",
                        header: "Name",
                        bodyStyle: "text-align: left"
                      }),
                      _createVNode(_component_Column, {
                        field: "phoneNumber",
                        header: "Phone Number",
                        bodyStyle: "text-align: left"
                      }),
                      _createVNode(_component_Column, {
                        header: "Accredited",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.accredited ? 'YES' : 'NO'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        header: "Related With Governament",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.relatedGovernment ? 'YES' : 'NO'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        header: "Actions",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_router_link, {
                            to: {
                      name: 'edit.beneficial',
                      params: { beneficialId: slotProps.data.id }
                    }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_55
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            header: "Reset Password",
            class: "shadow mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_56, [
                _createVNode("div", _hoisted_57, [
                  _createVNode(_component_Password, {
                    style: {"width":"100%"},
                    inputStyle: "width:100%",
                    toggleMask: "",
                    feedback: false,
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$v.password.$touch())),
                    placeholder: "Enter Current Password"
                  }, null, 8, ["modelValue"]),
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.password == '',
                'text-success': _ctx.password != ''
              }
                  }, "Value is required", 2),
                  _hoisted_58,
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.$v.password.minLength.$invalid || _ctx.password == '',
                'text-success': !_ctx.$v.password.minLength.$invalid
              }
                  }, "The min length value is 8", 2)
                ]),
                _createVNode("div", _hoisted_59, [
                  _createVNode(_component_Password, {
                    style: {"width":"100%"},
                    inputStyle: "width:100%",
                    toggleMask: "",
                    feedback: false,
                    modelValue: _ctx.newPassword,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newPassword = $event)),
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$v.newPassword.$touch())),
                    placeholder: "Enter New Password"
                  }, null, 8, ["modelValue"]),
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.$v.newPassword.required.$invalid,
                'text-success': !_ctx.$v.newPassword.required.$invalid
              }
                  }, "Value is required", 2),
                  _hoisted_60,
                  _createVNode("small", {
                    class: {
                'text-danger':
                  _ctx.$v.newPassword.minLength.$invalid || _ctx.newPassword == '',
                'text-success': !_ctx.$v.newPassword.minLength.$invalid
              }
                  }, "The min length value is 8", 2),
                  _hoisted_61,
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.$v.newPassword.containsUppercase.$invalid,
                'text-success': !_ctx.$v.newPassword.containsUppercase.$invalid
              }
                  }, "An uppercase value is required", 2),
                  _hoisted_62,
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.$v.newPassword.containsLowercase.$invalid,
                'text-success': !_ctx.$v.newPassword.containsLowercase.$invalid
              }
                  }, "An lowercase value is required", 2),
                  _hoisted_63,
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.$v.newPassword.containsNumber.$invalid,
                'text-success': !_ctx.$v.newPassword.containsNumber.$invalid
              }
                  }, "An number value is required", 2),
                  _hoisted_64,
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.$v.newPassword.containsSpecial.$invalid,
                'text-success': !_ctx.$v.newPassword.containsSpecial.$invalid
              }
                  }, "An special value (#?!@$%^&*-) is required", 2)
                ]),
                _createVNode("div", _hoisted_65, [
                  _createVNode(_component_Password, {
                    style: {"width":"100%"},
                    inputStyle: "width:100%",
                    toggleMask: "",
                    feedback: false,
                    modelValue: _ctx.confirm,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirm = $event)),
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$v.confirm.$touch())),
                    placeholder: "Repeat New Password"
                  }, null, 8, ["modelValue"]),
                  _createVNode("small", {
                    class: {
                'text-danger': _ctx.$v.confirm.sameAs.$invalid || _ctx.confirm == '',
                'text-success': !_ctx.$v.confirm.sameAs.$invalid
              }
                  }, "The value must be equal to the New Password value", 2)
                ])
              ]),
              _createVNode("div", _hoisted_66, [
                _createVNode("div", _hoisted_67, [
                  _createVNode("button", {
                    disabled: 
                _ctx.$v.password.$error ||
                _ctx.$v.newPassword.$error ||
                _ctx.$v.confirm.$error ||
                _ctx.noPasswords()
              ,
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args))),
                    class: "btn btn-primary btn-sat-street"
                  }, " Update Password ", 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            header: "Anti-phishing Code",
            class: "shadow mt-3 mb-5 text-left"
          }, {
            default: _withCtx(() => [
              _hoisted_68,
              _createVNode("div", _hoisted_69, [
                _createVNode("div", _hoisted_70, [
                  _withDirectives(_createVNode("input", {
                    placeholder: "Anti-phishing Code",
                    type: "text",
                    disabled: _ctx.isLoadingAntiPhising,
                    id: "anti-phishing-word",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.antiphishingWord = $event)),
                    class: "form-control",
                    maxlength: "16"
                  }, null, 8, ["disabled"]), [
                    [_vModelText, _ctx.antiphishingWord]
                  ]),
                  _createVNode("div", _hoisted_71, [
                    (_ctx.antiphishingWord?.length < 6)
                      ? (_openBlock(), _createBlock("small", _hoisted_72, " At least 6 characters. "))
                      : _createCommentVNode("", true),
                    _hoisted_73,
                    _hoisted_74
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_75, [
                _createVNode("div", _hoisted_76, [
                  _createVNode("button", {
                    class: "btn btn-primary btn-sat-street mr-3",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateAntiphishing && _ctx.updateAntiphishing(...args))),
                    disabled: _ctx.isLoadingAntiPhising || _ctx.antiphishingWord?.length < 6
                  }, " Change ", 8, ["disabled"]),
                  _createVNode("button", {
                    class: "btn btn-danger",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.removeAntiphishingWord && _ctx.removeAntiphishingWord(...args))),
                    disabled: _ctx.isLoadingAntiPhising || !_ctx.antiphishingWord
                  }, " Remove ", 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            header: "Help Section",
            class: "shadow mt-3 mb-5 text-left"
          }, {
            default: _withCtx(() => [
              _hoisted_77,
              _createVNode("ul", _hoisted_78, [
                _hoisted_79,
                _hoisted_80,
                _hoisted_81,
                _createVNode("li", null, [
                  _createVNode("a", {
                    href: "#",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showTermsModal = true))
                  }, " Terms Of Service ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Dialog, {
            header: "Satstreet",
            visible: _ctx.showTermsModal,
            "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (_ctx.showTermsModal = $event)),
            maximizable: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_82, [
                _hoisted_83,
                _hoisted_84,
                _createVNode(_component_Terms)
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : _createCommentVNode("", true)
  ]))
}